import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Icons from "../../myIcon/Icons";
import { usePermissions } from "../../helper/PermissionContext";

// Each top-level menu group = one permission slug from the API.
const MENU = {
  dashboard: "dashboard",
  homeManagement: "home-management",
  blogManagement: "blog-management",
  projectManagement: "project-management",
  careerManagement: "career-management",
  seoManagement: "seo-management",
  globalSeo: "global-seo",
  sitemapManagement: "sitemap-management",
  llmsManagement: "llms-management",
  robotsManagement: "robots-management",
  faqManagement: "faq-management",
  testimonials: "testimonials",
  clientLogos: "client-logos",
  howWeWork: "how-we-work",
  ourStats: "our-stats",
  contactUs: "contact-us",
  partnerWithUs: "partner-with-us",
  jobApplications: "job-applications",
  pmsReferral: "pms-referral",
  landingPage: "landing-page",
  dynamicPage: "dynamic-page",
  emailManagement: "email-management",
  userManagement: "user-management",
};

export default function SideBar({ isOpen, toggleSidebar }) {
  const [isBlogManagementOpen, setIsBlogManagementOpen] = useState(false);
  const [isProjectManagementOpen, setIsProjectManagementOpen] = useState(false);
  const [isJobManagementOpen, setIsJobManagementOpen] = useState(false);
  const [isUserManagementOpen, setIsUserManagementOpen] = useState(false);

  const { hasPermission } = usePermissions();

  const navigate = useNavigate();

  const toggleBlogManagement = () => setIsBlogManagementOpen((prev) => !prev);
  const toggleProjectManagement = () => setIsProjectManagementOpen((prev) => !prev);
  const toggleJobManagement = () => setIsJobManagementOpen((prev) => !prev);
  const toggleUserManagement = () => setIsUserManagementOpen((prev) => !prev);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  return (
    <>
      <div className={`admin-logo-wrap ${isOpen ? "close" : "open"}`}>
        <img src="/logo.webp" alt="logo" className="img-responsive" />
        <button className="toggle-button" onClick={toggleSidebar}>
          ☰
        </button>
      </div>
      <div className={`admin-sidebar ${isOpen ? "close" : "open"}`}>
        <div className="scroller-sidebar">
          <ul style={isOpen
            ? { transition: "all 0.3s ease-in", opacity: "0", visibility: "hidden" }
            : { transition: "all 0.3s ease-in", opacity: "1", visibility: "visible" }}>

            {hasPermission(MENU.dashboard) && (
              <li>
                <Link to="/"><span><img src="/assets/dashboard.webp" alt="icon" className="img-responsive" />Dashboard</span></Link>
              </li>
            )}

            {hasPermission(MENU.userManagement) && (
              <li className={`innertab ${isUserManagementOpen ? "openlist" : ""}`} onClick={toggleUserManagement}>
                <div><span><img src="/assets/dashboard.webp" alt="icon" className="img-responsive" /> User Management</span> <Icons name="arrowDown" /></div>
                <ul className={`nested-list ${isUserManagementOpen ? "open" : "close"}`}>
                  <li><Link to="users">Users</Link></li>
                  <li><Link to="roles">Roles</Link></li>
                  <li><Link to="permissions">Permissions</Link></li>
                </ul>
              </li>
            )}

            {hasPermission(MENU.homeManagement) && (
              <li>
                <Link to="/home"><span><img src="/assets/home-management.webp" alt="icon" className="img-responsive" />Home Management</span></Link>
              </li>
            )}

            {hasPermission(MENU.blogManagement) && (
              <li className={`innertab ${isBlogManagementOpen ? "openlist" : ""}`} onClick={toggleBlogManagement}>
                <div><span><img src="/assets/blog-management.webp" alt="icon" className="img-responsive" /> Blog Management</span> <Icons name="arrowDown" /></div>
                <ul className={`nested-list ${isBlogManagementOpen ? "open" : "close"}`}>
                  <li><Link to="blog">Blog</Link></li>
                  <li><Link to="category">Category</Link></li>
                  <li><Link to="author">Author</Link></li>
                </ul>
              </li>
            )}

            {hasPermission(MENU.projectManagement) && (
              <li className={`innertab ${isProjectManagementOpen ? "openlist" : ""}`} onClick={toggleProjectManagement}>
                <div><span><img src="/assets/project-management.webp" alt="icon" className="img-responsive" /> Project Management</span> <Icons name="arrowDown" /></div>
                <ul className={`nested-list ${isProjectManagementOpen ? "open" : "close"}`}>
                  <li><Link to="project">Project</Link></li>
                  <li><Link to="project-category">Category</Link></li>
                </ul>
              </li>
            )}

            {hasPermission(MENU.careerManagement) && (
              <li className={`innertab ${isJobManagementOpen ? "openlist" : ""}`} onClick={toggleJobManagement}>
                <div><span><img src="/assets/career-icon.webp" alt="icon" className="img-responsive" />Career Management</span> <Icons name="arrowDown" /></div>
                <ul className={`nested-list ${isJobManagementOpen ? "open" : "close"}`}>
                  <li><Link to="job">Job Post</Link></li>
                  <li><Link to="location">Location</Link></li>
                  <li><Link to="department">Department</Link></li>
                </ul>
              </li>
            )}

            {hasPermission(MENU.seoManagement) && (
              <li>
                <Link to="/seo"><span><img src="/assets/seo-management.webp" alt="icon" className="img-responsive" />SEO Management</span></Link>
              </li>
            )}

            {hasPermission(MENU.globalSeo) && (
              <li>
                <Link to="/global-seo"><span><img src="/assets/schema-management.webp" alt="icon" className="img-responsive" />Global SEO</span></Link>
              </li>
            )}

            {hasPermission(MENU.sitemapManagement) && (
              <li>
                <Link to="/sitemap"><span><img src="/assets/sitemap-management.webp" alt="icon" className="img-responsive" />Sitemap Management</span></Link>
              </li>
            )}

            {hasPermission(MENU.llmsManagement) && (
              <li>
                <Link to="/llms"><span><img src="/assets/sitemap-management.webp" alt="icon" className="img-responsive" />LLMS Management</span></Link>
              </li>
            )}

            {hasPermission(MENU.robotsManagement) && (
              <li>
                <Link to="/robots"><span><img src="/assets/sitemap-management.webp" alt="icon" className="img-responsive" />Robots.txt Management</span></Link>
              </li>
            )}

            {hasPermission(MENU.faqManagement) && (
              <li>
                <Link to="/faq"><span><img src="/assets/faq-icon.webp" alt="icon" className="img-responsive" />FAQ Management</span></Link>
              </li>
            )}

            {hasPermission(MENU.testimonials) && (
              <li>
                <Link to="/testimonial"><span><img src="/assets/testimonial.webp" alt="icon" className="img-responsive" />Testimonials</span></Link>
              </li>
            )}

            {hasPermission(MENU.clientLogos) && (
              <li>
                <Link to="/client-logo"><span><img src="/assets/logo-management.webp" alt="icon" className="img-responsive" />Client Logos</span></Link>
              </li>
            )}

            {hasPermission(MENU.howWeWork) && (
              <li>
                <Link to="/we-work"><span><img src="/assets/howwork.webp" alt="icon" className="img-responsive" />How We Work</span></Link>
              </li>
            )}

            {hasPermission(MENU.ourStats) && (
              <li>
                <Link to="/stats"><span><img src="/assets/stats-management.webp" alt="icon" className="img-responsive" />Our Stats</span></Link>
              </li>
            )}

            {hasPermission(MENU.contactUs) && (
              <li>
                <Link to="/contact"><span><img src="/assets/contact-management.webp" alt="icon" className="img-responsive" />Contact Us</span></Link>
              </li>
            )}

            {hasPermission(MENU.partnerWithUs) && (
              <li>
                <Link to="/partner-with-us"><span><img src="/assets/partner.webp" alt="icon" className="img-responsive" />Partner With Us</span></Link>
              </li>
            )}

            {hasPermission(MENU.jobApplications) && (
              <li>
                <Link to="/job-applications"><span><img src="/assets/job-app.webp" alt="icon" className="img-responsive" />Job Applications</span></Link>
              </li>
            )}

            {hasPermission(MENU.pmsReferral) && (
              <li>
                <Link to="/referral"><span><img src="/assets/refer.webp" alt="icon" className="img-responsive" />PMS Referral</span></Link>
              </li>
            )}

            {hasPermission(MENU.landingPage) && (
              <li>
                <Link to="/landing-page"><span><img src="/assets/landing.webp" alt="icon" className="img-responsive" />Landing Page</span></Link>
              </li>
            )}

            {hasPermission(MENU.dynamicPage) && (
              <li>
                <Link to="/dynamic"><span><img src="/assets/dynamic-page.webp" alt="icon" className="img-responsive" />Dynamic Page</span></Link>
              </li>
            )}

            {hasPermission(MENU.emailManagement) && (
              <li>
                <Link to="/email-management"><span><img src="/assets/contact-management.webp" alt="icon" className="img-responsive" />Email Management</span></Link>
              </li>
            )}

            
          </ul>
        </div>

        <button onClick={handleLogout} className="default-btn logout-button">Logout<span></span></button>
      </div>
    </>
  );
}
